var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPumpkin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.2 480",
    style: {
      enableBackground: "new 0 0 566.2 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:15;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.6,460c-15.4,7.6-32.1,11.8-49.6,11.8c-75.9,0-137.5-78.6-137.5-175.5S69.1,120.7,145,120.7 c17.5,0,34.2,4.2,49.6,11.8 M194.6,460 M194.6,132.5c-35.7,9.2-66,39-83.7,80 M262.4,140.7c-13.8-7.2-28.8-11.1-44.5-11.1 c-7.9,0-15.7,1-23.2,2.9 M111,212.5c-3.5,9.5-7.5,20.5-10.5,30.5c-5,16-6,33-7,50c-2,53,16,107,57,144c31,27,76,36,112.5,14.7  M370.6,460.1c18.9,9.9,40.9,13.9,61.9,11.9c11-2,22-5,33-9c16-7,29-18,42-29c1-1,1-3,2-4c21-21,33-47,41-75c6-23,9-45,8-68 c-1-13-2-26-5-40c-4-15-8-29-15-43c-12-21-24-40-44-55c-1-1-1-2-2-3c-11-6-20-14-32-17c-1,0-2-2-3-2c-29-10-62-9-88.6,5.8  M370.6,460.1 M330.4,429.3 M370.5,460.3c57.3-14.7,100.4-82.8,100-164.3c-0.4-81.3-44-148.8-101.2-163.2 M302.6,452.1 c14,7.3,29.2,11.3,45.1,11.2c7.8,0,15.4-1.1,22.8-3 M302.6,452.1 M369.3,132.8c-7.5-1.9-15.3-2.9-23.3-2.8 c-15.2,0.1-29.7,3.8-43.1,10.6 M302.9,140.6c-6.5-3.4-13.2-5.2-20.2-5.2c-7,0-13.9,1.8-20.4,5.3 M328.6,164.6 c-7.7-10.9-16.3-19.1-25.6-24 M302.6,452.1c34.4-17.8,59.9-80.8,59.9-155.8c0-54.4-13.4-102.6-33.9-131.7 M262,451.6 c6.6,3.6,13.6,5.5,20.7,5.5c6.8,0,13.5-1.7,19.8-5 M236.5,427.3c7.6,11,16.3,19.3,25.6,24.3 M262.4,140.7 c-34.2,18.2-59.4,80.9-59.4,155.5c0,54,13.2,101.9,33.5,131 M311.5,136.7l66.6-93.1c0,0-40-32.7-41.6-36S243.5,96.9,249.3,135"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpkin);
export default __webpack_public_path__ + "static/media/pumpkin.efe51bb6603a7edd722ddeb774f6d002.svg";
export { ForwardRef as ReactComponent };